import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { LoadingModalComponent } from './loading-modal.component';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
    ],
    exports: [LoadingModalComponent],
    declarations: [LoadingModalComponent],
})
export class LoadingModalModule
{
}
